var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paper-root"},[(_vm.header)?_c('div',{staticClass:"pl-3 d-flex align-items-center justify-content-between",class:{
            'py-2': !_vm.tall && !_vm.noHeaderPadding,
            'py-3': (_vm.tall || !_vm.tall) && !_vm.noHeaderPadding,
            'pr-3': !_vm.noHeaderPadding,
        }},[_c('h6',{staticClass:"subtitle bold heading mb-0",style:({
                'max-width': _vm.restrictHeaderWidth ? '90%' : null,
                'margin-left': _vm.offsetHeaderFromLeft ? '50px' : 'none',
            })},[_vm._v("\n            "+_vm._s(_vm.header.toUpperCase())+"\n        ")]),_vm._t("header")],2):_vm._e(),(_vm.header)?_c('Divider'):_vm._e(),(_vm.padding || _vm.custom_padding)?_c('div',{class:((_vm.custom_padding != ''
                    ? _vm.custom_padding
                    : 'p-' + (_vm.shouldUseDefaultPadding ? '2' : _vm.padding)) + " w-100")},[_vm._t("default")],2):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }